import _ from 'lodash'
import branchApi from '@/api/branch'
import store from '@/store'
import form from './form'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  errors: [],
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    restaurantId: 0,
    searchQuery: '',
    sortBy: '',
    sortDesc: false,
  },
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    state.loading = true
    branchApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
  },
  sync({ commit }, restaurant) {
    store.dispatch('message/load')
    commit('SYNC_STARTED')
    return branchApi.sync(restaurant)
      .then(() => commit('BRANCH_SYNCED'))
      .catch((error) => {
        commit('BRANCH_SYNC_FAILED', { errors: error.response.data.errors })
        throw error
      })
  },
  updateVisibility({ commit }, data) {
    return branchApi.updateVisibility(data)
      .then(() => commit('BRANCH_VISIBILITY_UPDATED', data))
      .catch((error) => {
        commit('BRANCH_VISIBILITY_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
}

const mutations = {
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
    state.filters.pageNumber = metadata.pageNumber
  },
  SYNC_STARTED(state) {
    store.dispatch('message/load')
  },
  BRANCH_SYNCED(state) {
    store.dispatch('message/loadFinish')
  },
  BRANCH_SYNC_FAILED(state) {
    store.dispatch('message/loadFinish')
    store.dispatch('message/error', '')
  },
  CLEAR_ERRORS(state) {
    state.errors = []
  },
  BRANCH_VISIBILITY_UPDATE_FAILED(state) {
    store.dispatch('message/error', '')
  },
  BRANCH_VISIBILITY_UPDATED() {
    store.dispatch('branch/fetchList')
  },
  ...generateFormHandlerMutations(state),
}

const modules = {
  form,
}

const watchers = [
  [state => state.branch.filters, _.debounce(async () => await store.dispatch('branch/fetchList'), 250), {
    immediate: false,
    deep: true,
  }],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
